import { useNavigate } from "react-router-dom";
import { postRodauth } from "../lib/rodauth";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { AdminSidebarContent } from "./AdminSidebarContent";

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { refetch } = useCurrentUser();

  const handleLogout = async () => {
    await postRodauth("/logout", {});
    await refetch();
    navigate("/login", { replace: true });
  };

  return (
    <aside className="hidden md:flex w-56 shrink-0 border-r border-primary-200 dark:border-primary-800 bg-white dark:bg-primary-900 min-h-screen flex-col">
      <AdminSidebarContent onLogout={handleLogout} />
    </aside>
  );
}
